module.exports = __webpack_public_path__ + "static/Hesham-5f34424fa46973e45a5b89a1cc0aadd5.png";